export const compareConstants = {
  TOGGLED_COMPARE_MODAL: 'TOGGLED_COMPARE_MODAL',
	ADD_FUNDIDS_TO_COMPARE_FUNDS: 'ADD_FUNDIDS_TO_COMPARE_FUNDS',
	UPDATE_FUNDIDS_TO_COMPARE_FUNDS: 'UPDATE_FUNDIDS_TO_COMPARE_FUNDS',
	UPDATE_TEMPORARY_COMPARE_FUNDS: 'UPDATE_TEMPORARY_COMPARE_FUNDS',
	REMOVED_TEMPORARY_COMPARE_FUNDS: 'REMOVED_TEMPORARY_COMPARE_FUNDS',
	RESET_TEMPORARY_COMPARE_FUNDS: 'RESET_TEMPORARY_COMPARE_FUNDS',

	FETCH_COMPARE_START: 'FETCH_COMPARE_START',
	FETCH_COMPARE_SUCCESS: 'FETCH_COMPARE_SUCCESS',
	FETCH_COMPARE_FAILURE: 'FETCH_COMPARE_FAILURE',

	FETCH_COMPARE_FUNDS_BY_PERIOD_START: 'FETCH_COMPARE_FUNDS_BY_PERIOD_START',
	FETCH_COMPARE_FUNDS_BY_PERIOD_SUCCESS: 'FETCH_COMPARE_FUNDS_BY_PERIOD_SUCCESS',
	FETCH_COMPARE_FUNDS_BY_PERIOD_FAILURE: 'FETCH_COMPARE_FUNDS_BY_PERIOD_FAILURE',

	FETCH_GRAPH_COMPARE_FUNDS_START: 'FETCH_GRAPH_COMPARE_FUNDS_START',
	FETCH_GRAPH_COMPARE_FUNDS_SUCCESS: 'FETCH_GRAPH_COMPARE_FUNDS_SUCCESS',
	FETCH_GRAPH_COMPARE_FUNDS_FAILURE: 'FETCH_GRAPH_COMPARE_FUNDS_FAILURE',

	FETCH_NAV_COMPARE_FUNDS_START: 'FETCH_NAV_COMPARE_FUNDS_START',
	FETCH_NAV_COMPARE_FUNDS_SUCCESS: 'FETCH_NAV_COMPARE_FUNDS_SUCCESS',
	FETCH_NAV_COMPARE_FUNDS_FAILURE: 'FETCH_NAV_COMPARE_FUNDS_FAILURE',

	CLEAR_FUND_COMPARE: 'CLEAR_FUND_COMPARE',

	TOGGLE_RETURN: 'TOGGLE_RETURN',
	TOGGLE_DRAWDOWN: 'TOGGLE_DRAWDOWN',
	TOGGLE_PROPORTION: 'TOGGLE_PROPORTION',

	INSERT_SEARCH_INDEX: 'INSERT_SEARCH_INDEX',
	// INSERT_SCROLL_POSITION: 'INSERT_SCROLL_POSITION'
};
